import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Clock, TrendingDown, Award, HeartHandshake, UserCheck } from 'lucide-react';
export function WhyLatam() {
  const features = [{
    icon: <MessageSquare className="w-6 h-6" style={{
      color: '#B388F5'
    }} data-id="element-290" />,
    title: 'Strong English Communication',
    desc: 'Carefully vetted professionals with exceptional written and verbal English skills.'
  }, {
    icon: <Clock className="w-6 h-6 text-pink" data-id="element-291" />,
    title: 'Time Zone Alignment',
    desc: 'Seamless collaboration with overlapping working hours across US and Canadian time zones.'
  }, {
    icon: <TrendingDown className="w-6 h-6 text-coral" data-id="element-292" />,
    title: 'Cost-Efficient Growth',
    desc: 'Access premium talent while optimizing your hiring budget by 40-60%.'
  }, {
    icon: <Award className="w-6 h-6" style={{
      color: '#B388F5'
    }} data-id="element-293" />,
    title: 'Highly Skilled Talent Pool',
    desc: 'A rapidly growing ecosystem of educated, experienced, and specialized professionals.'
  }, {
    icon: <HeartHandshake className="w-6 h-6 text-pink" data-id="element-294" />,
    title: 'Cultural Compatibility',
    desc: 'Strong alignment with North American business culture and work ethic.'
  }, {
    icon: <UserCheck className="w-6 h-6 text-coral" data-id="element-295" />,
    title: 'Long-Term Team Members',
    desc: 'Dedicated professionals looking for stable, long-term career opportunities.'
  }];
  const stats = [{
    value: '40–60%',
    label: 'Average Savings'
  }, {
    value: 'Same',
    label: 'Time Zone'
  }, {
    value: '20+',
    label: 'Countries'
  }, {
    value: '5–10',
    label: 'Day Shortlist'
  }];
  return <section className="py-24 bg-navy" data-id="element-296">
      <div className="max-w-7xl mx-auto px-6" data-id="element-297">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-298">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-299">
            Why Latin America?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-300" data-id="element-300">
            The ideal balance of talent, collaboration, and cost-efficiency.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-301">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 p-8 rounded-3xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-302">
              <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center mb-6" data-id="element-303">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-304">
                {feature.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-305">{feature.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 rounded-3xl p-8 border border-white/10 backdrop-blur-sm" data-id="element-306">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x-0 md:divide-x divide-white/10" data-id="element-307">
            {stats.map((stat, index) => <div key={index} className="text-center px-4" data-id="element-308">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-309">
                  {stat.value}
                </div>
                <div className="text-sm font-medium text-slate-400 uppercase" data-id="element-310">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}